export interface StartInput {
    name: string;
    label: string;
    type: "text" | "number" | "boolean";
    required: boolean;
    default?: string | number | boolean;
}

export const parseStartInputs = (raw: unknown): StartInput[] => {
    try {
        const entries = typeof raw === "string" ? JSON.parse(raw) : raw;
        return Array.isArray(entries) ? entries.filter((entry): entry is StartInput =>
            Boolean(entry && typeof entry === "object" && typeof entry.name === "string")) : [];
    } catch (_error) {
        return [];
    }
};

export const startInputName = (label: string): string => {
    const slug = label.normalize("NFD").replace(/[\u0300-\u036f]/g, "")
        .toLowerCase().replace(/[^a-z0-9]+/g, "_").replace(/^_+|_+$/g, "")
        .replace(/^[^a-z]+/, "").replace(/_+$/g, "");
    return slug || "pergunta";
};
